import config from '../config';
import {SET_FEATURE_FLAGS} from '../actions/constants/action-types';


const featureFlagsReducer = (state = config.features, action) => {
    switch (action.type) {
        case SET_FEATURE_FLAGS: {
            return {
                ...state,
                ...action.payload
            };
        }
        default:
            return state;
    }
};

export default featureFlagsReducer;
